import angular from 'angular';
import uiRouter from 'angular-ui-router';
import toCentsDirective from './toCents.directive';
import googleAutocomplete from '../../../common/directives/googleAutocomplete';

import OfficeDeliveryDetailsComponent  from './officeDelivery.component';

const OfficeDeliveryDetailsModule = angular.module('tinaba.components.services.officeDelivery', [
  uiRouter
])
  .config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.officeDelivery', {
      url: '/officeDelivery',
      template: '<office-delivery-details></office-delivery-details>'
    });
  })

  .component('officeDeliveryDetails', OfficeDeliveryDetailsComponent)

  //.directive('toMillis', toMillisDirective)
  .directive('toCents', toCentsDirective)
  .directive('googleAutocomplete', googleAutocomplete)
;

export default OfficeDeliveryDetailsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/officeDelivery/officeDelivery.js
 **/